module.exports = __webpack_public_path__ + "img/leftprice.163f754b.svg";